import { CommonResponseModel } from '@needle-management/shared-models';
import { Injectable } from '@nestjs/common';
import { MachinesNeedleMappingRepository } from './machine-needle-mapping.repo';
import { MachineNeedleMappingDto } from './dto/machine-needle-mapping.dto';
import { MachinesNeedleMappingEntity } from './entity/machine-needle-mapping.entity';
import { NeedleMappingActivateDeactivateDto } from '@needle-management/shared-models';

@Injectable()
export class MachineNeedleMappingService {
    constructor(
        private machineNeedleMappingRepo: MachinesNeedleMappingRepository,
    ) { }


    // async createMachinesNeedleMapping(req: MachineNeedleMappingDto): Promise<CommonResponseModel> {
    //     console.log(req);
    //     try {
    //         const existingNeedleMapping = await this.machineNeedleMappingRepo.findOne({
    //             where: { 
    //                 needleSizes: req.needleSizes,
    //                 styles: req.styles, 
    //                 machines: req.machines, 
    //                 needleModel: req.needleModel, 
    //                 needlePointType: req.needlePointType },
    //             relations: ['styles', 'machines', 'needleModel', 'needlePointType', 'needleSizes']
    //         });
    //         if (existingNeedleMapping) { return new CommonResponseModel(false, 0, `Needle Mapping with the given data already exists.`, []); }
    //         const entity = new MachinesNeedleMappingEntity();
    //         entity.styles = req.styles;
    //         entity.machines = req.machines;
    //         entity.needleModel = req.needleModel;
    //         entity.needlePointType = req.needlePointType;
    //         entity.needleSizes = req.needleSizes;
    //         entity.isActive = req.isActive;
    //         entity.createdUser = req.createdUser;
    //         entity.updatedUser = req.updatedUser;
    //         entity.versionFlag = req.versionFlag;
    //         const save = await this.machineNeedleMappingRepo.save(entity);
    //         if (save) {
    //             return new CommonResponseModel(true, 1, 'Created successfully', save);
    //         } else {
    //             return new CommonResponseModel(false, 0, 'Something went wrong in Needle Mapping creation', []);
    //         }
    //     } catch (err) {
    //         console.error(err);
    //         return new CommonResponseModel(false, 0, 'An error occurred during creation', []);
    //     }
    // }

    async createMachinesNeedleMapping(req: MachineNeedleMappingDto): Promise<CommonResponseModel> {
        try {
            let checkCombination = await this.machineNeedleMappingRepo.findOne({where:{machinesId:req.machinesId,needleModelId:req.needleModelId,needlePointTypeId:req.needlePointTypeId,needleSizesId:req.needleSizesId,stylesId:req.stylesId}});
            if(checkCombination.id > 0){
                return new CommonResponseModel(false, 0, 'Mapping exist. ', []);
            }
            else{
                console.log(req);
                const entity = new MachinesNeedleMappingEntity();
                entity.stylesId = req.stylesId;
                entity.machinesId = req.machinesId;
                entity.needleModelId = req.needleModelId;
                entity.needlePointTypeId = req.needlePointTypeId;
                entity.needleSizesId = req.needleSizesId;
            
                const save = await this.machineNeedleMappingRepo.save(entity);
                if (save) {
                    return new CommonResponseModel(true, 1, 'Created successfully', save);
                } else {
                    return new CommonResponseModel(false, 0, 'Something went wrong in Branch creation', []);
                }
            }
        } catch (err) {
            throw err;
        }
    }

    async getAllMachinesNeedleMapping(): Promise<CommonResponseModel> {
        const result = await this.machineNeedleMappingRepo.getAllMachineNeedleMappingQuery()
        if (result.length > 0) {
            return new CommonResponseModel(true, 1, 'Data retrieved successfully', result);
        }
        return new CommonResponseModel(true, 1, 'No data found', []);
    }

    async getActiveMachinesNeedleMapping(): Promise<CommonResponseModel> {
        const data = await this.machineNeedleMappingRepo.find({ where: { isActive: true } });
        if (data.length > 0) {
            return new CommonResponseModel(true, 1, 'Data retrieved successfully', data);
        }
        return new CommonResponseModel(true, 1, 'No active Needle Size data found', []);
    }

    async deleteMachinesNeedleMapping(req: MachineNeedleMappingDto): Promise<CommonResponseModel> {
        try {
            const result = await this.machineNeedleMappingRepo.delete(
                { id: req.id },
            );

            if (result.affected > 0) {
                return new CommonResponseModel(true, 1, 'Deleted successfully', result);
            } else {
                return new CommonResponseModel(false, 0, 'Deleted failed', []);
            }
        } catch (error) {
            console.log(error);
        }
    }

    async updateMachinesNeedleMapping(req: MachineNeedleMappingDto): Promise<CommonResponseModel> {
        console.log(req),"rururu";
        try {
            const result = await this.machineNeedleMappingRepo.update(
                { id: req.id },
                { 
                    stylesId: req.stylesId,
                    machinesId: req.machinesId,
                    needleModelId: req.needleModelId,
                    needlePointTypeId: req.needlePointTypeId,
                    needleSizesId: req.needleSizesId,
                    updatedUser: req.updatedUser, 
                    isActive: req.isActive }
            );
            if (result.affected > 0) {
                return new CommonResponseModel(true, 1, 'Updated successfully', result);
            } else {
                return new CommonResponseModel(false, 0, 'Update failed', []);
            }
        } catch (error) {
            console.log(error);
        }
    }

    async activateOrDeactivateMachinesNeedleMapping(req: NeedleMappingActivateDeactivateDto): Promise<CommonResponseModel> {
        try {
            const exists = await this.machineNeedleMappingRepo.findOne({ where: { id: req.id } });
            if (!exists) {
                throw new CommonResponseModel(false, 99998, 'No Needle Mapping found');
            }
            const update = await this.machineNeedleMappingRepo.update(
                { id: req.id },
                { isActive: req.isActive, updatedUser: req.updatedUser }
            );
            if (exists.isActive && !req.isActive) {
                if (update.affected) {
                    return new CommonResponseModel(true, 1, 'Needle Mapping deactivated successfully');
                } else {
                    throw new CommonResponseModel(false, 0, 'Needle Mapping already deactivated');
                }
            } else if (!exists.isActive && req.isActive) {
                if (update.affected) {
                    return new CommonResponseModel(true, 1, 'Needle Mapping  activated successfully');
                } else {
                    throw new CommonResponseModel(false, 0, 'Needle Mapping  already activated');
                }
            } else {
                return new CommonResponseModel(false, 0, 'No changes were made');
            }
        } catch (err) {
            return err;
        }
    }
}
